import { FC, useEffect } from 'react'

import { useLocation, useNavigate } from '@tanstack/react-router'

import { Link, Logo, Stack, Typography } from '@forto-dev/phoenix-ui-core/common'
import { Splash } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

import { LoginForm } from './LoginForm'
import { useAuth } from '../../api/useAuth'
import { LanguageSwitcher } from '../../LanguageSwitcher'

export const Login: FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { translate } = useLocalisation()
  const { isLoggedIn, login, isLoggingIn, shouldHideLogin } = useAuth()

  useEffect(() => {
    const currentPath = location.pathname
      .replace(new RegExp(`^${window.config?.APP_BASE_URL}`), '/')
      .replace(/^\/{2,}/, '/')
    if (isLoggedIn && currentPath === '/login') {
      navigate({
        to: String('redirect' in location.search ? location.search.redirect : '/'),
        from: location.pathname,
      })
    }
  }, [isLoggedIn, location, navigate])

  if (shouldHideLogin) {
    return null
  }

  return (
    <Splash>
      <Stack gap={16} data-testid="login-page">
        <Logo />
        <Stack gap={4}>
          <Typography variant="h3">{translate('login.title')}</Typography>
          <Typography variant="body">
            {translate('login.prompt')}{' '}
            <Link href={translate('login.signUp.url')} target="_blank" rel="noopener noreferrer">
              {translate('login.signUp.label')}
            </Link>
          </Typography>
        </Stack>
        <LoginForm onFormSubmit={login} disabled={isLoggingIn} />
        <LanguageSwitcher />
      </Stack>
    </Splash>
  )
}
